_ = require 'underscore'
Hearsay = require 'hearsay'
PluginRunner = require 'views/internal/plugins/plugin-runner'
PluginView = require 'views/plugin/plugin-view'
Promise = require 'bluebird'
pluginValidators = require 'lib/util/plugin-validators'
sandboxParams = require 'data/plugin-iframe-sandbox'
t = require('views/internal/teacup-with-helpers')('plugin_section')

template = t.renderable (data) ->
  { content, iframeType } = data
  t.div '.window-module.u-clearfix', ->

    t.div '.window-module-title.window-module-title-no-divider', ->
      t.span '.window-module-title-icon.icon-lg.plugin-section-icon.js-icon'
      t.h3 '.u-inline-block.plugin-section-title.js-title'
      return

    if content.type == 'iframe' && pluginValidators.isValidUrlForIframe(content.url)
      { url, height } = content
      if !pluginValidators.isValidHeight(height, 400)
        height = 400
      t.div '.u-gutter', ->
        t.iframe '.plugin-iframe.plugin-section.plugin-card-back-section',
          allow: 'microphone; camera'
          sandbox: sandboxParams
          src: url
          style: t.stylify
            height: if height then "#{ height }px;" else undefined
        return
    return
  return

module.exports = class PluginCardBackSectionView extends PluginView

  initialize: ->
    @section = new Hearsay.Slot(null)

  renderOnce: ->
    section = @section.get()
    if !section?
      throw Error('updateSection not called before render')

    @$el.html(template(section))

    @subscribe @section, (latestSection) =>
      Promise.resolve(_.result(latestSection, 'title'))
      .then (title) =>
        @$('.js-title').text(title)
      .catch PluginRunner.Error.Timeout, (->)

      Promise.resolve(_.result(latestSection, 'icon'))
      .then (icon) =>
        @$('.js-icon').css('background-image', t.urlify(t.addRecolorParam(icon, "?color=999")))
      .catch PluginRunner.Error.Timeout, (->)
    @initIFrames(@model.getBoard(), @model, @section)

    @

  updateSection: (section) ->
    @section.set(section)



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-card-back-section-view.coffee